<template>
  <div class="ele-body">
    <el-card shadow="never" class="report-card">
      <!-- 美丽的标题 -->
      <div class="report-title">
        <div class="title-icon">
          <i class="el-icon-data-analysis"></i>
        </div>
        <h2>统计报表</h2>
        <p>实时查看您的业务数据</p>
      </div>

      <!-- 搜索表单 -->
      <el-form :model="where" label-width="100px" class="search-form" @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :lg="12" :md="12">
            <el-form-item label="选择时间">
              <el-date-picker v-model="where.time" type="daterange" range-separator="～" start-placeholder="开始日期"
                value-format="yyyy-MM-dd" end-placeholder="结束日期" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="button-group">
              <el-button type="primary" icon="el-icon-search" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <!-- 数据卡片 -->
      <div class="data-cards" v-loading="loading">
        <div class="card-row">
          <div class="data-card" v-for="item in dataList" :key="item.cny_name">
            <div class="card-header">
              <div class="currency-icon">
                <i class="el-icon-coin"></i>
              </div>
              <h3>{{ item.cny_name }}</h3>
            </div>

            <!-- 代收数据 -->
            <div class="card-section">
              <div class="section-title">
                <i class="el-icon-_red-packet"></i>
                代收数据
              </div>
              <div class="data-row">
                <div class="data-item">
                  <span class="data-label">成功条数</span>
                  <span class="data-value">{{ item.in_count || 0 }}</span>
                </div>
                <div class="data-item">
                  <span class="data-label">金额（元）</span>
                  <span class="data-value">{{ item.in_paymentAmount || 0 }}</span>
                </div>
              </div>
              <div class="data-row">
                <div class="data-item">
                  <span class="data-label">费率（元）</span>
                  <span class="data-value">{{ item.in_fees || 0 }}</span>
                </div>
                <div class="data-item">
                  <span class="data-label">手续费（元）</span>
                  <span class="data-value">{{ item.in_rate || 0 }}</span>
                </div>
              </div>
            </div>

            <!-- 代付数据 -->
            <div class="card-section">
              <div class="section-title">
                <i class="el-icon-wallet"></i>
                代付数据
              </div>
              <div class="data-row">
                <div class="data-item">
                  <span class="data-label">成功条数</span>
                  <span class="data-value">{{ item.out_count || 0 }}</span>
                </div>
                <div class="data-item">
                  <span class="data-label">金额（元）</span>
                  <span class="data-value">{{ item.out_paymentAmount || 0 }}</span>
                </div>
              </div>
              <div class="data-row">
                <div class="data-item">
                  <span class="data-label">费率（元）</span>
                  <span class="data-value">{{ item.out_fees || 0 }}</span>
                </div>
                <div class="data-item">
                  <span class="data-label">手续费（元）</span>
                  <span class="data-value">{{ item.out_rate || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'bussiness',
  data() {
    return {
      // 数据接口
      url: '/Reconciliation/bussiness',
      // 数据列表
      dataList: [],
      loading: false,
      // 搜索条件
      where: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    /* 获取数据 */
    getData() {
      this.loading = true;
      this.$http.post(this.url, { where: this.where }).then((res) => {
        if (res.data.code === 0) {
          this.dataList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      });
    },
    /* 刷新数据 */
    reload() {
      this.getData();
    },
    /* 重置搜索 */
    reset() {
      this.where = {};
      this.getData();
    }
  }
}
</script>

<style scoped>
/* 标题美化 */
.report-title {
  text-align: center;
  margin-bottom: 20px;
  padding: 20px 15px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}

.title-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
}

.title-icon i {
  font-size: 32px;
  color: white;
}

.report-title h2 {
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  margin: 8px 0;
  position: relative;
  z-index: 1;
}

.report-title p {
  font-size: 13px;
  color: #909399;
  margin: 0;
  position: relative;
  z-index: 1;
}

/* 搜索表单 */
.search-form {
  margin-bottom: 15px;
  padding: 15px;
  background: #fafbfc;
  border-radius: 12px;
}

.button-group {
  display: flex;
  gap: 10px;
}

::v-deep .el-button {
  border-radius: 8px;
  font-weight: 500;
  padding: 8px 16px;
}

::v-deep .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

::v-deep .el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

/* 数据卡片 */
.data-cards {
  padding: 10px 0;
}

.card-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

@media (max-width: 1600px) {
  .card-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1200px) {
  .card-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

.data-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 15px;
  transition: all 0.3s ease;
  border: 1px solid #f0f2f5;
}

.data-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.15);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f2f5;
}

.currency-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 12px rgba(102, 126, 234, 0.3);
  flex-shrink: 0;
}

.currency-icon i {
  font-size: 22px;
  color: white;
}

.card-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.card-section {
  margin-bottom: 12px;
  padding: 10px;
  background: #fafbfc;
  border-radius: 8px;
}

.card-section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 8px;
}

.section-title i {
  font-size: 16px;
}

.data-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 8px;
}

.data-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.data-label {
  font-size: 12px;
  color: #909399;
  font-weight: 500;
}

.data-value {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

/* 响应式 */
@media (max-width: 992px) {
  .card-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .card-row {
    grid-template-columns: 1fr;
  }

  .data-row {
    grid-template-columns: 1fr;
  }

  .report-title h2 {
    font-size: 20px;
  }

  .title-icon {
    width: 50px;
    height: 50px;
  }

  .title-icon i {
    font-size: 28px;
  }

  .report-title {
    padding: 15px 10px;
  }
}
</style>

<style>
.el-form-item label {
  font-weight: bold;
  font-size: 16px;
}
</style>
